import { FC } from "react";
import { Box, BoxProps } from "@xcorejs/ui";
import NextIcon from "components/icons/16/next.svg";
import styled from "styled-components";

const NewsStackStyle = styled(Box)<BoxProps>`
  position: relative;
  
  & > div {
    
    & > *:not(:last-child) {
      margin-bottom: 2rem;
    }
  }
`;

const NewsStack: FC<BoxProps> = (
  {
    children,
    ...props
  }
) => {
  return (
    <NewsStackStyle width="100%" {...props}>
      {children}
    </NewsStackStyle>
  );
};

export default NewsStack;
